<template>
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="grid grid-flow-col grid-cols-10 pt-10">
      <div
        class="hidden lg:block col-span-2 grid justify-center justify-items-center	border-r"
      >
        <img :src="user.picture" alt="" class="w-40 mb-4" />
        <div class="mb-10"></div>
        <ul class="grid gap-6">
          <li>
            <router-link to="/account" class="flex items-center">
              <Icon name="Setting" class="w-6 mr-5" />
              <p>Account Settings</p>
            </router-link>
          </li>
          <li>
            <a
              href="https://adbox2.canny.io/feature-requests-and-bug-reports"
              target="_blank"
              class="flex items-center"
            >
              <Icon
                name="KnowledgeRequest"
                viewbox="0 0 120 120"
                fill="#111111"
                stroke
                class="w-6 mr-5"
                font-weight="300"
              />
              <span>Knowledge Requests</span>
            </a>
          </li>
          <li>
            <router-link to="/account/subscription" class="flex items-center">
              <Icon name="CreditCard" class="w-6 mr-5" />
              <p>Billing</p>
            </router-link>
          </li>
          <li>
            <router-link to="/account/support" class="flex items-center">
              <Icon name="Support" class="w-6 mr-5" />
              <p>Support</p>
            </router-link>
          </li>
          <li>
            <a
              href="https://adbox.getrewardful.com/signup"
              target="_blank"
              class="flex items-center"
            >
              <Icon
                name="Affiliate"
                viewbox="0 0 120 120"
                fill="#111111"
                stroke="#111111"
                class="w-6 mr-5"
                font-weight="300"
              />
              <span>Become an Affiliate</span>
            </a>
          </li>
          <li>
            <a
              class="flex items-center cursor-pointer"
              @click="signoutVisible = true"
            >
              <Icon name="Logout" class="w-6 mr-5" />
              <p>Sign Out</p>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-span-full lg:col-span-8 px-2 lg:px-10">
        <router-view />
      </div>
    </div>
  </div>
  <SignOutModal v-model:isVisible="signoutVisible" />
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import HeaderApp from "@/components/Header";
import Icon from "@/components/UI/Icon";
import SignOutModal from "@/components/Modals/SignOut";

export default {
  components: { HeaderApp, Icon, SignOutModal },
  setup() {
    const store = useStore();

    const signoutVisible = ref(false);

    const user = computed(() => store.state.user);

    return { signoutVisible, user };
  },
};
</script>

<style></style>
